export default __webpack_public_path__ + "MOt_reports.html";